import { useRoles } from '@/hooks/useRoles';
import { useMemo } from 'react';

export interface InstrumentPermissions {
  /** POR-447: UI gate only — the API still lets any org_admin POST an instrument (POR-470). */
  canCreate: boolean;
}

/** Keyed on the platform-wide flag, like the Organizations page and portal-backend's
 *  `transfer_instrument`. Deliberately not a per-org `super_user` role check — a per-org GRANT
 *  satisfies that, which portal-backend's authorization audit flags as AUTHZ-03 (still open). */
export const useInstrumentPermissions = (): InstrumentPermissions => {
  const { isGlobalSuperAdmin } = useRoles();
  const isSuperUser = isGlobalSuperAdmin();

  return useMemo(() => ({ canCreate: isSuperUser }), [isSuperUser]);
};
